import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';

export const NotifyBodyB = () => {
    const breadcrumbLinks = [       
        { path: '/', label: 'Home' },
        { label: 'Notified Body Transition Details', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Notified Body Transition Details" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
<section className="service-details section-space">
  <div className="container">
    <div className="row flex-xl-row flex-column-reverse">
      <div className="col-xl-4">
        <div className="sidebar sidebar-rr-sticky">
          <div className="sidebar__widget-service mb-30">
            <Link to="/service">
              Medical Device Manufacturers <i className="fa-solid fa-plus"></i>
            </Link>
            <Link to="/pharmaceutical-details">
              Pharmaceutical & Biotech industry <i className="fa-solid fa-plus"></i>
            </Link>
            <Link to="/healthcare-details">
              Healthcare Providers <i className="fa-solid fa-plus"></i>
            </Link>
          </div>

          <div className="sidebar__widget-contact__service text-center">
            <h4 className="mb-25 title-animation text-capitalize">
              Are You ready to contact with us
            </h4>
            <p className="mb-20">
              <a href="tel:+86 19811976744">
                <i className="fa-solid fa-phone"></i>(+86) 19811976744
              </a>
            </p>

            <Link to="/contact-us#" className="rr-btn">
              <span className="btn-wrap">
                <span className="text-one">
                  Contact Us <i className="fa-solid fa-plus"></i>
                </span>
                <span className="text-two">
                  Contact Us <i className="fa-solid fa-plus"></i>
                </span>
              </span>
            </Link>
          </div>
        </div>
      </div>
      <div className="col-xl-8">
        <div className="service-details__content">
          {/* Existing content */}
          <div className="service-details__content-media mb-20">
            <img
              src="./assets/imgs/service-details/service-details-1.jpg"
              className="img-fluid"
              alt="img not found"
            />
          </div>
          <h2 className="title-animation mb-20">Notified Body Transition</h2>

          <p className="mb-20">
            We offer a variety of solutions to efficiently manage transition projects. While each transition project is unique, our process remains consistent.
          </p>
          <h4 className="title-animation mb-15">How SQUARE MEDTECH can help in Medical Writing?</h4>
          <ul className="mb-40">
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              Support for necessary Clinical Evidence
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              Regulatory Documents for Clinical Evaluations
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              Literature Search
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              Statistical Evaluations
            </li>
          </ul>
          <h3 className="title-animation mb-15">
            Fill up the Gap by Medical Writing
          </h3>
          <p>
            We support you in medical writing all documents required in a clinical evaluation process or clinical investigations. Our experts utilize templates and forms to ensure the completeness and regulatory compliance of these numerous documents.
          </p>

          <h5 className="title-animation mb-15"> <i className="fa-solid fa-vial text-primary"></i> <strong>Clinical Evaluation</strong></h5>
<p>
  SQUARE MEDTECH assists you in developing the necessary clinical evidence for your medical device, ensuring alignment with your intended purpose, claims, and technical documentation with proper planning, preparation, and conduct of perfect clinical evaluations through the following services.
</p>
<h5> <i className="fa-solid fa-vial text-primary"></i> Clinical Data Strategy:</h5>
<p>
  SQUARE MEDTECH assists you in planning and maintaining an efficient clinical data strategy from product development through to the post-market phase. A well-planned strategy can expedite your device's market entry and bolster your marketing efforts. Our goal in developing a clinical data strategy is to ensure that investigations provide the necessary clinical evidence to support your claims, while also optimizing the use of your resources.
</p>
<h5> <i className="fa-solid fa-vial text-primary"></i> Clinical Evaluation Plan & Report:</h5>
<p>
  SQUARE MEDTECH team can help you develop and update your clinical evaluation documentation to ensure they fulfill regulatory criteria. Clinical assessment is an essential link between the technical file and clinical investigation. It is a systematic and continuing procedure that validates the device's safety and performance, including clinical benefits.
</p>
<h5> <i className="fa-solid fa-vial text-primary"></i> Clinical Evaluation SOP:</h5>
<p>
  SQUARE MEDTECH team can support you in creating Standard Operating Procedures (SOPs). SOP is a detailed document outlining the processes and procedures involved in conducting a clinical evaluation of a medical device. The SOP ensures that clinical evaluations are performed consistently, thoroughly, and in compliance with regulatory requirements. Our efforts can save your time by ensuring the right fit for your device.
</p>

<div className="row">
            <div className="col-lg-7">
              <div className="service-details__content-media-item service-details__content-media-item-1">
                <div className="service-details__content-media-item_img mb-10">
                  <img
                    src="./assets/imgs/service-details/service-details-2.jpg"
                    className="img-fluid"
                    alt="img not found"
                  />
                </div>
                <h4 className="title-animation mb-15"><i class="fa fa-circle-o text-danger"></i> Our Expertise in Clinical Evaluation</h4>
                <p>
                At SQUARE MEDTECH, we specialize in comprehensive clinical evaluation, ensuring medical devices meet stringent regulatory requirements. Our expertise spans clinical data analysis, risk assessment, and systematic literature reviews to support regulatory submissions. We help clients navigate complex regulatory landscapes for successful market entry.
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="service-details__content-media-item service-details__content-media-item-2">
                <div className="service-details__content-media-item_img mb-10">
                  <img
                    src="./assets/imgs/service-details/service-details-3.jpg"
                    className="img-fluid"
                    alt="img not found"
                  />
                </div>
                <h4 className="title-animation mb-15"><i class="fa fa-circle-o text-danger"></i>Why Choose Us for Clinical Evaluation</h4>
                <p>
                Choose SQUARE MEDTECH for expert clinical evaluation with regulatory compliance, robust methodologies, and tailored solutions. Our team ensures accurate data analysis, risk assessment, and seamless regulatory approval, supporting your medical device’s success with efficiency, reliability, and industry-leading expertise.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
  <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our Clinical Evaluation Services</h4>
                        <ul  class="color-white mb-0">
                        <li>Support for Safety & Performance</li>
                        <li>Develop and update CE documentations</li>
                        <li> Alignment with Intended purpose, Claims</li>

                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our Clinical Evaluation Services</h4>
                        <ul  class="color-white mb-0">
                        <li>Clinical Evidence support</li>
                        <li> Efficient clinical data strategy</li>
                        <li>Standard Operating Procedure</li>
                      </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

    </main>


    
    <FooterWhite/>
    </>
  )
}
